import { queryString } from '../utils/window'
import { getIsDesktop, getIsNativeApp } from '../utils/ua'
import { getCurrentCountryCode } from '../providers/geolocationProvider'
import { injectElement, logger } from '../application/injectDynamicContent'
import { AD_FORMATS, CLASS_NAMES as AD_CLASS_NAMES } from '../organizedByType/config/adsConfig'
import { getIsPostPage, getIsEmbededPost, getIsTopX } from '../application/pageDataObject'

const { adsDebugDynamicSlot } = queryString
const isNonEmbeddedPostPageOnMobile = (getIsPostPage() && !getIsEmbededPost()) || getIsTopX()
const DFP_DYNAMIC_SLOT_BLACK_LISTED_COUNTRY_CODES = ['DE']
const { BLOCK, EMPTY, INJECTED, DFP } = AD_CLASS_NAMES
const INJECTED_ELEMENT_CONF_DFP_SLOT = {
  className: [BLOCK, INJECTED, EMPTY, DFP].join(' '),
  dataset: {
    slotId: AD_FORMATS.InArticleDynamic,
  },
}

function isDfpDynamicSlotEnabled() {
  // Unlike in web, in the app we get the cc via the 'countryCode' queryString.
  // That's why currentCountryCode is actually the current countryCode, without fetching.
  if (
    getIsNativeApp() &&
    DFP_DYNAMIC_SLOT_BLACK_LISTED_COUNTRY_CODES.includes(getCurrentCountryCode())
  ) {
    return false
  }

  return isNonEmbeddedPostPageOnMobile
}

export function initDfpDynamicSlot(config) {
  const dfpLogger = logger.part(adsDebugDynamicSlot, 'dfpDynamicSlot:')
  if (!isDfpDynamicSlotEnabled()) {
    dfpLogger('disabled', { isDfpDynamicSlotEnabled, isNonEmbeddedPostPageOnMobile })
    return false
  }
  return injectElement(INJECTED_ELEMENT_CONF_DFP_SLOT, dfpLogger)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/config/adInjectedDfpDynamicSlotConfig.js